import React from 'react';
import {FormControl, FormHelperText, Flex} from '@chakra-ui/react';
import Select from 'react-select';
import {
  AiFieldDefinitionConfig,
  isCustomerAnalysisField,
  isKeyplayAnalysisField,
  KeyplayAnalysisFieldLabels,
  KeyplayAnalysisFields,
} from '../../../shared/fields/enrichment';
import {useAgentBuilderServerState} from './AgentBuilder.state';
import {ConfigFormLabel} from './ConfigFormLabel';

const keyplayAnalysisFieldOptions = KeyplayAnalysisFields.map((field) => ({
  label: KeyplayAnalysisFieldLabels[field],
  value: field,
}));

export const AnalysisFieldsEditor = ({
  config,
  isDisabled = false,
  onConfigChange,
}: {
  config: AiFieldDefinitionConfig;
  isDisabled?: boolean;
  onConfigChange: (config: AiFieldDefinitionConfig) => void;
}) => {
  const agent = useAgentBuilderServerState();
  const isResearchAgent =
    agent.type === 'legacyResearchAndAnalyst' ||
    agent.type === 'researchAndAnalyst';

  const existingCustomerAnalysisFields = config.analysisFields.filter(
    isCustomerAnalysisField
  );
  const existingKeyplayAnalysisFields = config.analysisFields.filter(
    isKeyplayAnalysisField
  );

  return (
    <FormControl as={Flex} direction="column" gap="6">
      <Flex direction="column">
        <ConfigFormLabel>
          {isResearchAgent
            ? "Answer based on analysis of your Researcher's findings and"
            : 'Answer based on analysis of'}
        </ConfigFormLabel>

        <Select
          isDisabled={isDisabled}
          isMulti
          menuPlacement="auto"
          onChange={(selectedOptions) => {
            const fieldValues = selectedOptions.map(({value}) => value);
            const analysisFields = isResearchAgent
              ? // automatically re-add the researcher field since they are not
                // visible in the UI
                [...existingCustomerAnalysisFields, ...fieldValues]
              : fieldValues;

            onConfigChange({
              ...config,
              analysisFields,
            });
          }}
          options={keyplayAnalysisFieldOptions}
          placeholder="Select field(s)"
          value={existingKeyplayAnalysisFields.map((analysisField) => ({
            value: analysisField,
            label: KeyplayAnalysisFieldLabels[analysisField],
          }))}
        />
        <FormHelperText textColor="kgray.300">
          Add as many fields as are relevant.
        </FormHelperText>
      </Flex>
    </FormControl>
  );
};
